import { Nullable } from '~/types/common';
import { InsightDto, ChannelSummaryData } from '~/api/insights';

export type CampaignsSummaryFilters = {
  startDate: Nullable<string>;
  endDate: Nullable<string>;
};
export enum DateFilterType {
  DATE_RANGE = 'dateRange',
  TOTAL = 'total',
}

export enum CampaignStatisticName {
  REACH = 'reach',
  IMPRESSIONS = 'impressions',
  AMOUNT_SPENT = 'amountSpent',
  CLICKS = 'clicks',
  CPC = 'cpc',
  CTS = 'cts',
}
export enum InsightType {
  CAMPAIGN = 'campaign',
  ADSET = 'adset',
  AD = 'ad',
}

export type InsightsFilters = {
  startDate?: Nullable<string>;
  endDate?: Nullable<string>;
  type?: InsightType;
  childrenOf?: Nullable<{ id: string; label: string }>;
  page?: number;
  perPage?: number;
};

export type HierarchyNode = {
  id: string;
  label: string;
  type: InsightType;
};

export type InsightsContext = {
  filters: InsightsFilters;
  rows: InsightDto[];
  totalRowsCount: number;
  summary: ChannelSummaryData;
  hierarchyPath: HierarchyNode[];
};

export type Channel = 'meta' | 'google' | 'tiktok';

export type ProgramSummary = {
  campaignCost: number;
  totalBalance: number;
  timeRemaining: number;
};

export type PracticeROI = {
  practiceRevenue: number;
  practiceROI: number;
  costPerLead: number;
  costPerConsult: number;
  costPerProcedure: number;
  hasData: boolean;
};

export type ConversionFunnel = {
  totalLeads: number;
  consultsBooked: number;
  consultsCompleted: number;
  proceduresBooked: number;
  proceduresCompleted: number;
  otherServices: number;
  hasData: boolean;
};

export type ChannelMetrics = {
  reach: number;
  impressions: number;
  leads: number;
  costPerLead: number;
  clicks: number;
  costPerClick: number;
};

export type ConnectedChannels = {
  channels: Channel[];
  hasData: Record<Channel, boolean>;
};

export type ChannelFilters = {
  activeChannel: Channel | 'all';
  startDate: string | null;
  endDate: string | null;
};

export type ChannelDetails = {
  rows: any[];
  totalCount: number;
  page: number;
  perPage: number;
};

export type PromotePageContext = {
  programSummary: ProgramSummary;
  practiceROI: PracticeROI;
  conversionFunnel: ConversionFunnel;
  connectedChannels: ConnectedChannels;
  channelFilters: ChannelFilters;
  channelSummary: ChannelMetrics;
  channelDetails: ChannelDetails;
};

export type ColumnDefinition = {
  name: string;
  rowKey: string;
  frozen?: boolean;
  label?: string;
};

export type ChannelColumnConfig = Record<Channel, ColumnDefinition[]>;
